import { render, staticRenderFns } from "./save-documents-maintenance-input.vue?vue&type=template&id=1075df27&scoped=true&"
import script from "./save-documents-maintenance-input.vue?vue&type=script&lang=js&"
export * from "./save-documents-maintenance-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1075df27",
  null
  
)

export default component.exports